import React, { ReactNode, CSSProperties } from "react";
import styles from "./ListItem.module.css";
import { Link } from "react-router-dom";
import clsx from "clsx";

type Columns =
  | string
  | Array<string | number>;
// string: "2fr 2fr 3fr 2fr auto"
// array: [2, 2, 3, 2, "auto"] -> стане "2fr 2fr 3fr 2fr auto"

interface Props {
  children: ReactNode;
  className?: string;

  link?: string;
  onClick?: () => void;
  actions?: ReactNode;
  actionsOnHover?: boolean;
  disabled?: boolean;

  /** Grid layout for cells (excluding actions column). */
  columns?: Columns;

  /** Gap between columns */
  gap?: number | string;

  /** Align items vertically inside the row */
  align?: "center" | "start" | "end";
}

function toGridTemplate(columns?: Columns) {
  if (!columns) return undefined;
  if (typeof columns === "string") return columns;

  return columns
    .map((c) => (typeof c === "number" ? `${c}fr` : c))
    .join(" ");
}

export const ListItem: React.FC<Props> & {
  Cell: React.FC<{ children: ReactNode; className?: string; title?: string }>;
} = ({
  children,
  className,
  link,
  onClick,
  actions,
  actionsOnHover = false,
  disabled = false,
  columns,
  gap = 12,
  align = "center",
}) => {
    const commonStyle = {
      display: "grid",
      gridTemplateColumns: actions
        ? `${toGridTemplate(columns)} auto`
        : toGridTemplate(columns),
      columnGap: typeof gap === "number" ? `${gap}px` : gap,
      alignItems: "center",
    };

    const commonClass = [
      styles.item,
      styles.grid, // новий клас
      !disabled ? styles.clickable : "",
      className ?? "",
    ]
      .filter(Boolean)
      .join(" ");

    const content = (
      <>
        {children}

        {actions && (
          <div
            className={clsx('additionButtons', styles.actions, /* actionsOnHover && styles.actionsHover */)}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            {actions}
          </div>
        )}
      </>
    );

    if (link && !disabled) {
      return (
        <Link to={link} className={commonClass} style={commonStyle}>
          {content}
        </Link>
      );
    }

    if (onClick && !disabled) {
      return (
        <button
          type="button"
          onClick={onClick}
          className={commonClass}
          style={commonStyle}
        >
          {content}
        </button>
      );
    }

    return (
      <div className={commonClass} style={commonStyle}>
        {content}
      </div>
    );
  };

ListItem.Cell = ({ children, className, title }) => {
  return (
    <div className={[styles.cell, className ?? ""].filter(Boolean).join(" ")} title={title}>
      {children}
    </div>
  );
};